// extracted by mini-css-extract-plugin
export var dropdownIcon = "_il-6";
export var imgContainer = "_il-3";
export var menuIcon = "_il-5";
export var pillWrapper = "_il-2";
export var pillsContainer = "_il-1";
export var subscriptionCard = "_il-0";
export var subscriptionLogo = "_il-4";